import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const familyApiService = createApi({
  reducerPath: 'familyApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/family/'),
  tagTypes: ['FamilyLinks'],
  endpoints: (builder) => ({
    // Get all family links (admin)
    getFamilyLinks: builder.query({
      query: (args) => {
        let params = queryParams(args)
        return `admin/links${params}`
      },
      providesTags: ['FamilyLinks'],
      keepUnusedDataFor: 0
    }),
    
    // Create family link (admin)
    createFamilyLink: builder.mutation({
      query: (payload) => ({
        url: 'admin/link',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['FamilyLinks']
    }),
    
    // Update family link status (admin)
    updateFamilyLink: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `admin/link/${id}`,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['FamilyLinks']
    }),
    
    // Get location history for a link (admin)
    getLocationHistory: builder.query({
      query: ({ id, hours = 24 }) => `admin/link/${id}/history?hours=${hours}`,
      keepUnusedDataFor: 0
    }),
    
    // Get audit log for a link (admin)
    getAuditLog: builder.query({
      query: ({ id, page = 1, limit = 50 }) => 
        `admin/audit/${id}?page=${page}&limit=${limit}`,
      keepUnusedDataFor: 0
    }),
    
    // Get users for dropdown selection (admin)
    getUsersForLinking: builder.query({
      query: (args) => {
        let params = queryParams(args)
        return `admin/users${params}`
      },
      keepUnusedDataFor: 0
    }),
  })
})

export const {
  useGetFamilyLinksQuery,
  useCreateFamilyLinkMutation,
  useUpdateFamilyLinkMutation,
  useGetLocationHistoryQuery,
  useGetAuditLogQuery,
  useGetUsersForLinkingQuery,
} = familyApiService

